import React, { useEffect, useState } from "react";

const getWeekNumber = (date) => {
    const startOfWeek = new Date(date.getFullYear(), 0, 1);
    const days = Math.floor((date - startOfWeek) / (24 * 60 * 60 * 1000));
    const weekNumber = Math.ceil((days + startOfWeek.getDay() + 1) / 7);
  
    return weekNumber;
  };

// Function to group data by date
const groupDataByDate = (data) => {
    return data.reduce((groupedData, item) => {
      const date = new Date(item.date_intervention);
      const monthYear = `${date.getMonth() + 1}-${date.getFullYear()}`;
      const week = getWeekNumber(date);
  
      if (!groupedData[monthYear]) {
        groupedData[monthYear] = {};
      }
  
      if (!groupedData[monthYear][week]) {
        groupedData[monthYear][week] = [];
      }
  
      groupedData[monthYear][week].push(item);
  
      return groupedData;
    }, {});
  };

export const FilterButtons = () => {
  const [plannedTasks, setPlannedTasks] = useState([]);
  const [groupedPlannedTasks, setGroupedPlannedTasks] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null); 
  const [selectedWeek, setSelectedWeek] = useState(null);


  const apiUrl = 'https://lebontechnicien.net'

  //fetching Data
  useEffect(() => {
    fetch(`${apiUrl}request/history`, { method: "GET" })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const fetchedPlanned = data.filter(
          (task) =>
            task.status === "Pending" && task.temp_status === "Planned"
        );
  
        // Convert date strings to Date objects
        fetchedPlanned.forEach((task) => {
          task.date_intervention = new Date(task.date_intervention);
        });
  
        // Group the data by date
        const groupedData = groupDataByDate(fetchedPlanned);
  
        setGroupedPlannedTasks(groupedData);
        console.log("Grouped Planned tasks", groupedData);
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle errors here
      });
  }, []);
  



  const renderMonthButtons = () => {
    return Object.keys(groupedPlannedTasks).map((month) => (
      <button key={month} onClick={() => handleMonthClick(month)}>
        {month}
      </button>
    ));
  };

  const renderWeekButtons = (weeks) => {
    return Object.keys(weeks).map((week) => (
      <button key={week} onClick={() => handleWeekClick(week)}>
        {week}
      </button>
    ));
  };
  
  const renderDayButtons = (days) => {
    return Object.keys(days).map((day) => (
      <button key={day} onClick={() => handleDayClick(day)}>
        {day}
      </button>
    ));
  };
  

  const handleMonthClick = (month) => {
    // Handle month click logic
    console.log("Selected Month:", month);
  };

  const handleWeekClick = (week) => {
    // Handle week click logic
    console.log("Selected Week:", week);
  };

  const handleDayClick = (day) => {
    // Handle day click logic
    console.log("Selected Day:", day);
  };

  return (
<div>
    <h2>Month Selection</h2>
    {renderMonthButtons()}
    {groupedPlannedTasks && renderWeekButtons(groupedPlannedTasks[selectedMonth])}
    {groupedPlannedTasks && renderDayButtons(groupedPlannedTasks[selectedMonth][selectedWeek])}
  </div>
  );
};
